<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form #ta="ngForm" class="formborder">
    <div class="col-md-12 row my-2" style="display: flex; align-items: center">
      <div class="col-md-2">
        <span>Date</span>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="CaseDateFrom"
            id="DateSelected"
            class="form-control input-text-css"
            [(ngModel)]="DateSelected"
            required
            #refen_month_year="ngModel"
            [ngClass]="{
              'is-invalid': ta.submitted && refen_month_year.invalid,
              'alert-warning':
                refen_month_year.invalid &&
                (refen_month_year.dirty ||
                  refen_month_year.touched ||
                  refen_month_year.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>

      <div class="col-md-2">
        <span> Source Type </span>
        <select
          name="SelectSourceType"
          id="SelectSourceType"
          #refSelectSourceType="ngModel"
          [ngClass]="{
            'is-invalid': ta.submitted && refSelectSourceType.invalid,
            'alert-warning':
              refSelectSourceType.invalid &&
              (refSelectSourceType.dirty ||
                refSelectSourceType.touched ||
                refSelectSourceType.untouched)
          }"
          (change)="Get_PartnerForDropdown()"
          [(ngModel)]="SelectSourceType"
          class="form-control input-text-css"
        >
          <option value="">Select Source Type</option>
          <option
            *ngFor="let lead of leadSourceDropdown"
            [value]="lead.Lead_Source"
          >
            {{ lead.Lead_Source_DisplayName }}
          </option>
        </select>
      </div>

      <ng-container
        *ngIf="
          SelectSourceType == 'Agent' ||
          SelectSourceType == 'DSA' ||
          SelectSourceType == 'Dealer' ||
          SelectSourceType == 'Sales Executive' ||
          SelectSourceType == 'Telecaller Executive' ||
          SelectSourceType == 'Marketing Executive'
        "
      >
        <div class="col-md-3">
          <span> Source Name</span>
          <select
            name="LeadSourceName"
            id="LeadSourceName"
            #refLeadSourceName="ngModel"
            [ngClass]="{
              'is-invalid': ta.submitted && refLeadSourceName.invalid,
              'alert-warning':
                refLeadSourceName.invalid &&
                (refLeadSourceName.dirty ||
                  refLeadSourceName.touched ||
                  refLeadSourceName.untouched)
            }"
            [(ngModel)]="LeadSourceName"
            class="form-control input-text-css"
          >
            <option value="">Select Lead Reference</option>
            <option
              *ngFor="let partner of partnerDropdown"
              [value]="partner.PartnerId"
            >
              {{ partner.Partner_Name }}
            </option>
          </select>
        </div>
      </ng-container>

      <!-- <div class="col-md-2 mt-3">
        <button
          class="btn font-size-12 button-btn ml-3"
          (click)="onsearch()"
          [disabled]="ta.form.invalid"
        >
          View Data
        </button>
      </div>
      <button
          class="mt-3 btn font-size-12 button-btn"
          (click)="exportExcel()"
        >
          <i
            class="fa fa-file-export mr-1"
            style="font-size: medium; cursor: pointer"
          ></i>
          Export Data
        </button> -->
        <div class="col-md-2">
          <span class="required-lable">Actions</span>

          <select
           name="selectedAction"
            id="selectedAction"
            class="form-control input-text-css"
            [(ngModel)]="selectedAction"
            required
            #refselectedAction="ngModel"
            [ngClass]="{
              'is-invalid': ta.submitted && refselectedAction.invalid,
              'alert-warning':
                refselectedAction.invalid &&
                (refselectedAction.dirty ||
                  refselectedAction.touched ||
                  refselectedAction.untouched)
            }"
          >
            <option value="">Select Action</option>
            <option value="view">View Data</option>
            <option value="export">Export Data</option>
            </select>
            </div>
            <div class="col-md-2 p-1">
              <span> Branch</span>
              <select name="Branch" id="Branch" #refSelectGender="ngModel" [(ngModel)]="SelectedBranch"
                class="form-control input-text-css">
                <option value="0">Select Branch</option>
                <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
                  {{ branch.Branch_Name }}
                </option>
              </select>
            </div>
              <div class="col-md-4">
      <span> Select Product </span>
      <select
        name="FilterBranchId"
        id="FilterBranchId"
        [(ngModel)]="ProductId"
        class="form-control input-text-css"
      >
        <option value="0">Select Product</option>
        <option *ngFor="let Product of productList" [value]="Product.ProductId">
          {{ Product.Product }}
        </option>
      </select>
    </div>
            <div class="col-md-2 mt-3">
              <button class="btn font-size-12 button-btn ml-3"
          (click)="handleAction()"
          [disabled]="ta.form.invalid"
        >
         Submit
        </button>
        </div>



      <div class="col-md-3 mt-2">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
  <div cdkDropListGroup>
    <div
      id="DeleteContainer"
      class="scrollmenu"
      *ngIf="columns.length > 0"
      [cdkDragData]="{ name: 'DeleteCol', columIndex: 100 }"
      cdkDropList
      (cdkDropListDropped)="onColumnDrop($event)"
    >
      <span
        class="btn-group-toggle m-2"
        data-toggle="buttons"
        *ngFor="let column of columnshow; let i = index"
        cdkDrag
        [cdkDragData]="{ name: column, columIndex: i }"
      >
        <label
          class="btn py-0 px-1"
          [ngClass]="{ 'btn-secondary': displayedColumns.includes(column) }"
        >
          <input
            type="checkbox"
            [checked]="displayedColumns.includes(column)"
            autocomplete="off"
            (change)="checkedChange($event)"
            [id]="column"
          />
          {{ column }}
        </label>
      </span>
    </div>

    <div
      class=""
      style="height: 65vh; overflow: auto"
      *ngIf="this.dataSource.data.length > 0"
    >
      <div class="table-responsive mt-3">
        <section
          class="table-container mat-elevation-z8"
          tabindex="0"
          style="height: 65vh"
        >
          <mat-table
            id="TableInfo"
            [dataSource]="dataSource"
            class="mat-elevation-z8"
            matSort
            cdkDropList
            cdkDropListOrientation="horizontal"
            style="min-width: max-content"
            matSort
            (cdkDropListDropped)="onColumnDrop($event)"
          > 
            <!-- <ng-container matColumnDef="SrNo">
              <mat-header-cell *matHeaderCellDef class="text-center columnclass">
                Sr No
              </mat-header-cell>

              <mat-cell *matCellDef="let row; let i = index" class="columnclass width50">
                {{ paginator?.pageIndex * paginator?.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container> -->
            <ng-container
              *ngFor="let column of columns; let i = index"
              [matColumnDef]="column.field"
            >
              <mat-header-cell
                class="text-center columnclass"
                *matHeaderCellDef
                cdkDrag
                cdkDragPlaceholder
                [cdkDragData]="{ name: column.field, columIndex: i }"
                mat-sort-header
              >
                {{ column.field }}
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="columnclass">
                {{ row[column.field] }}
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>
            <mat-row
              (click)="selectHighligh(i)"
              *matRowDef="let row; let i = index; columns: displayedColumns"
              style="text-align: center"
              [ngClass]="{ highlight: selectedRow == i }"
            ></mat-row>
          </mat-table>
        </section>
      </div>
    </div>
    <div
      class="row m-0 ml-3 mr-3 pt-2 pb-1"
      [hidden]="!(this.dataSource)"
    >
      <!-- <div class="col-md-4">
          <button class="btn btn-success font-size-12" (click)="exportTable()">
            <i class="fa fa-file-export mr-1" style="font-size:medium;cursor: pointer;"></i> Export
          </button>
        </div> -->
      <!-- <div class="col-md-4">
        <button
          class="mt-3 btn font-size-12 button-btn"
          (click)="exportExcel()"
        >
          <i
            class="fa fa-file-export mr-1"
            style="font-size: medium; cursor: pointer"
          ></i>
          Export
        </button>
      </div> -->
      <div class="col-md-8 text-right">
         Total Record {{totalRecords}}
          <mat-paginator [pageSize]="50" [pageSizeOptions]="[50, 100, 500]" showFirstLastButtons>
      </mat-paginator>
        <!-- <mat-paginator
          #paginatorRef
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator> -->
      </div>
    </div>
  </div>
</div>

<!-- <table
  *ngIf="dataSource.data.length > 0"
  id="master_component"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th
      *ngFor="let header of displayedColumns"
      style="background: #4dc3a3 !important; border: 1px solid white"
    >
      {{ header }}
    </th>
  </tr>
  <tr *ngFor="let data of dataSource.data; let ind = index">
    <td *ngFor="let header of displayedColumns">{{ data[header] }}</td>
  </tr>
</table> -->
